import { render, staticRenderFns } from "./zjhTable.vue?vue&type=template&id=4955d9e7&scoped=true"
import script from "./zjhTable.vue?vue&type=script&lang=ts"
export * from "./zjhTable.vue?vue&type=script&lang=ts"
import style0 from "./zjhTable.vue?vue&type=style&index=0&id=4955d9e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955d9e7",
  null
  
)

export default component.exports